<template>
    <div class="why-insurance mb-60">
        <div class="center-text own-title mb-10">
            Why Insurance
        </div>
        <div class="caption caption-margins round-medium bottom-10 card mobile-display" :style="loadMobileUmbrellaBg">
            <div class="umbrella-wrapper mobile-display">
                <img v-bind:src="'images/mpower/insurance/mobile/umbrella.jpg'" />
            </div>
            <div class="umbrella-text-wrapper mobile-display">
                <img v-bind:src="'images/mpower/insurance/mobile/umbrella_text.gif'" class="max-100 umbrella-mobile-img" />
            </div>
        </div>
        <div class="caption caption-margins round-medium bottom-10 card ipad-display" :style="loadTabletUmbrellaBg">
            <img v-bind:src="'images/mpower/insurance/tablet/umbrella.png'" class="umbrella-tablet-img" />
        </div>
        <div class="custom-divider"></div>
        <div class="content text-left">
            <p class="p-insurance-font line-height-normal mb-10">
                When you buy a life insurance policy, the <span class="font-italic bold">rule of thumb</span> is to insure a sum 
                equivalent to <span class="font-italic bold">10 times your annual salary.</span>
            </p>
            <p class="p-insurance-font line-height-normal mb-10">
                With Malaysia's gross income per capita of RM32,000, the
                <span class="font-italic bold">current average sum assured of RM50,000</span>
                is far below the ideal amount one should be insured for.
            </p> 
            <p class="p-insurance-font line-height-normal mb-10">
                This means that Malaysians are generally unprepared for rainy days. Imagine if something unfortunate were 
                to happen to the family's breadwinner and they're only left with a RM50,000 life insurance policy. Today,
                <span class="font-italic bold">RM50,000 will not get the family very far.</span> 
                They may have <span class="font-italic bold">difficulties sustaining their current standard 
                of living.</span>
            </p>
        </div>
        <div class="custom-divider"></div>
        <div class="content subheading-title text-left mb-10">
            Overview of Market Outlook
        </div>
        <div class="bottom-0">
            <div class="grid-half grid-bg padding-15">
                <div class="icon-column-center">
                    <img :src="'images/mpower/insurance/mobile/grid-image-1.png'" class="grid-image" />
                    <div class="grid-title">32.6 Million</div>
                    <div class="grid-description line-height-normal">Malaysian Populations in 2020*</div>
                </div>
            </div>
            <div class="grid-half grid-bg padding-15 last-column">
                <div class="icon-column-center">
                    <img :src="'images/mpower/insurance/mobile/grid-image-2.png'" class="grid-image" />
                    <div class="grid-title">RM1.63 trillion</div>
                    <div class="grid-description line-height-normal">Total Sum Assured for all policies in 2020*</div>
                    <div class="grid-description line-height-normal">(Traditional+Investment-Linked)</div>
                </div>
            </div>
            <div class="grid-half grid-bg padding-15">
                <div class="icon-column-center">
                    <img :src="'images/mpower/insurance/mobile/grid-image-3.png'" class="grid-image" />
                    <div class="grid-title">RM50,000</div>
                    <div class="grid-description line-height-normal">Average Sum Assured per capita in 2020*</div>
                </div>
            </div>
            <div class="grid-half grid-bg padding-15 last-column">
                <div class="icon-column-center">
                    <img :src="'images/mpower/insurance/mobile/grid-image-4.png'" class="grid-image" />
                    <div class="grid-title">55%</div>
                    <div class="grid-description line-height-normal">Life insurance penetration Rate in 2020*</div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="content source-title line-height-normal text-left">
            <span>Source:*2020 Industry Performance at <br>http://www.liam.org.my/index.php/library/statistics</span>
        </div>
        <div class="caption caption-margins round-medium mb-30 card mobile-display" :style="loadMobileQuestionBg">
            <img v-bind:src="'images/mpower/insurance/mobile/question_text_lg.gif'" class="question-mobile-img" />
        </div>
        <div class="caption caption-margins round-medium mb-30 card ipad-display" :style="loadTabletQuestionBg">
            <img v-bind:src="'images/mpower/insurance/tablet/question_text.gif'" class="question-img" />
        </div>
        <div class="content bottom-0">
            <a href="#" class="clear">
                <div class="one-half large-half text-left">
                    <p class="normal-highlight">
                        There are still many Malaysians are <span class="red-highlight">under-insured</span>
                    </p>
                </div>
                <div class="one-half small-half last-column">
                    <div class="caption round-small">
                        <div class="caption-image">
                            <img :src="'images/mpower/insurance/mobile/under_insured.png'" class="responsive-image mobile-display">
                            <img :src="'images/mpower/insurance/tablet/under_insured.png'" class="responsive-image ipad-display">
                        </div>
                    </div>
                </div>
            </a>
            <a href="#" class="clear">
                <div class="one-half small-half">
                    <div class="caption round-small">
                        <div class="caption-image">
                            <img :src="'images/mpower/insurance/mobile/protection.png'" class="responsive-image mobile-display">
                            <img :src="'images/mpower/insurance/tablet/protection.png'" class="responsive-image ipad-display">
                        </div>
                    </div>
                </div>
                <div class="one-half large-half last-column text-left">
                    <p class="normal-highlight">
                        We need more and <span class="red-highlight">higher protection</span>
                    </p>    
                </div>
            </a>
            <div class="clear"></div>
        </div>
        <div class="content">
            <div class="responsive-iframe border-rad-15 bottom-20">
                <iframe src='https://www.youtube.com/embed/4FJ7bKw7V7A' frameborder='0' allowfullscreen></iframe>
            </div>
        </div>
        <div class="divider divider-margins"></div>
    </div>
</template>
<style scoped> 
.mb-10 {
    margin-bottom: 10px !important;
}
.mb-30 {
    margin-bottom: 30px !important;
}
.mb-60 {
    margin-bottom: 60px !important;
}
.subheading-title {
    font-size: 14px;
    color: #fff;
    font-weight: bold;
}
.source-title {
    margin-top: 10px !important;
    font-size : 9px;
    color : rgb(255,255,255,0.4);
}
.normal-highlight {
    font-size: 20px;
    color: rgb(255,255,255,0.7);
    line-height: normal;
}
.red-highlight {
    font-size: 20px;
    font-weight: bold;
    color: #E44F59;
}
.grid-bg {
    background : #2B2B2B;
}
.grid-title {
    font-weight : bold;
    font-size : 15px;
    color : #54D2E3;
    margin: 5px 0 5px 0;
}
.grid-description {
    font-size: 9px;
    color: rgb(255,255,255,0.7);
}
.grid-half {
    width: 49.5%;
    margin-right: 1%;
    float: left;
    height: 150px;
}
.grid-half.last-column {
    width: 49.5%;
    margin: 0% 0% 1% 0%;
    float: left;
}
.umbrella-wrapper {
    position: absolute;
}
.umbrella-text-wrapper {
    position: relative;
}
.umbrella-tablet-img{
    max-width: 100%; 
    margin: 0 12%;
}
.umbrella-mobile-img {
    max-height: 197px;
    margin: 0 auto;
}
.question-mobile-img {
    max-width: 100%;
    max-height: 197px;
    margin: 0 auto;
}
.question-img {
    max-width: 100%;
    margin: 0 auto;
}
.text-left {
    text-align: left;
}
.grid-image {
    margin: 0 auto;
}
.img-resize {
    max-width: 50%;
    max-height: 100%;
    margin: 0 auto;
}
.border-rad-15 {
    border-radius: 15px;
}
.p-insurance-font {
    font-size : 11px;
    color: rgb(255,255,255,0.8) !important;
}
@media (max-width: 575px){
    .img-resize{
        max-width: 100% !important;
    }
}
@media (max-width: 765px){
    .normal-highlight {
        font-size: 11px !important;
    }
    .red-highlight {
        font-size: 13px !important;
    }
}
</style>
<script>
export default {
    name: 'Insurance',
    computed: {
        loadTabletUmbrellaBg(){
            return {
                'backgroundImage':'url(\'images/mpower/insurance/tablet/umbrella_text.gif\')',
                'background-repeat': 'no-repeat',
                'background-position': 'center',
                'background-size': 'contain',
                'background-color': '#ffffff',
                'opacity': '0.88'
            }
        },
        loadMobileUmbrellaBg() {
            return {
                'backgroundImage':'url(\'images/mpower/insurance/mobile/rectangle_bg.jpg\')',
                'background-repeat': 'no-repeat',
                'background-size': 'cover',
                'opacity': '0.88',
                'height': '197px'
            }
        },
        loadMobileQuestionBg() {
            return {
                'backgroundImage':'url(\'images/mpower/insurance/tablet/question.jpg\')',
                'background-repeat': 'no-repeat',
                'background-size': 'cover',
                'background-position': 'center'
            }
        },
        loadTabletQuestionBg() {
            return {
                'backgroundImage':'url(\'images/mpower/insurance/tablet/question.jpg\')',
                'background-repeat': 'no-repeat',
                'background-size': 'cover',
                'background-position': 'center'
            }
        }
    }
}
</script>